import { Component, OnInit } from '@angular/core';
import {MatSnackBar} from '@angular/material';
import { DoctorService } from '../../services/doctor.service';
import {ActivatedRoute, Router, Params } from '@angular/router';
import { NgForm } from '@angular/forms';
import { CommonService } from '../../services/common.service';
@Component({
  selector: 'app-asktovet',
  templateUrl: './asktovet.component.html',
  styleUrls: ['./asktovet.component.css']
})
export class AsktovetComponent implements OnInit {
  timer: any;
  msg: string;
  action: any;
  public loading = false;
  poststatus = 0;
  lifestage: any;
  breed: any;
  counter = 4;
  uid: any;
  user: any;
  pettype = [];
  selected_pet_type;
  constructor(public snackBar: MatSnackBar, private doctorService: DoctorService,
     private router: Router, private commonService: CommonService) {
      this.timer = setInterval(() => this.timedelay(), 1000);
      }

  ngOnInit() {
    this.commonService.getLifestages()
    .subscribe(
      (x) => {
        this.lifestage = x;
      }
     );
     this.doctorService.getallBreeds()
     .subscribe(
       (x) => {
         this.breed = x;
         for ( let i = 0 ; i < this.breed.length; i++) {
          if (this.breed[i].parent_id === 0 && (this.breed[i].name === 'dog' || this.breed[i].name === 'cat') ) {
             this.pettype.push(this.breed[i]);
          }
         }
       }
      );
  }
  timedelay() {
    this.counter = this.counter  - 1;
    if (this.counter === 0) {
      const udata = this.commonService.getUserDataLocally();
      this.uid = udata.uid;
      clearInterval(this.timer);
      this.loading = false;
      this.getUserDetail()
    }
  }
  getUserDetail() {
    this.loading = true;
    this.doctorService.getCommentedUserDetail(this.uid)
    .subscribe(
    (x) => {
      this.user = x;
      this.loading = false;
    });
  }
  askToVet(form: NgForm) {
    this.loading = true;
      this.doctorService.askAVet(form.value.title , form.value.desc  , 'forum.html' , 'forum.jpeg' ,
       'forum', form.value.cat , form.value.pettype, form.value.breed, form.value.life, this.uid)
      .subscribe(
        () => {
          this.poststatus = 1;
          this.loading = false;
          this.msg = 'Posted Successfully';
          this.openSnackBar();
        });
  }
  openSnackBar() {
    this.snackBar.open(this.msg, this.action , {
      duration: 4000,
    });
  }
  goBack() {
    this.router.navigate(['/forum/home']);
  }
}
